// tenantTheme.js
// テナントのアクセント色を config/app.accent_color から CSS 変数 --tenant-accent に差し込む。
// AKUTO ブランド: テナントが変えてよいのはアクセント1色とロゴだけ(灰色・文字・角丸は AKUTO のまま)。
// 未設定・不正値なら index.css の既定(スチールブルー)のまま。色は管理画面の7色から選ぶ(白文字4.5:1以上の色だけ)。
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { TENANT_ID } from "../tenant";

const hexToRgb = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || "").trim());
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
};

export function applyTenantTheme() {
  getDoc(doc(db, "tenants", TENANT_ID, "config", "app"))
    .then((snap) => {
      const rgb = hexToRgb(snap.data()?.accent_color);
      if (rgb) document.documentElement.style.setProperty("--tenant-accent", rgb);
    })
    .catch(() => {});
}
